/**
 * Facebook Marketing API integration - DISABLED
 */

// Cache structure maintained for compatibility
const metaDataCache = {
  campaigns: {},
  adSets: {},
  ads: {}
};

/**
 * DISABLED - Returns null without making any API calls
 */
export const getCampaignData = async (campaignId) => {
  return null;
};

/**
 * DISABLED - Returns null without making any API calls
 */
export const getAdSetData = async (adSetId) => {
  return null;
};

/**
 * DISABLED - Returns null without making any API calls
 */
export const getAdData = async (adId) => {
  return null;
};

/**
 * DISABLED - Returns null without making any API calls
 */
export const getAdManagerUrl = (type, id) => {
  return null;
};

/**
 * Parse Facebook ad IDs from lead ref data
 * Returns an object with campaign, adset, and ad IDs
 * Kept for compatibility but doesn't make any API calls
 */
export const parseMetaIdsFromRef = (refData) => {
  if (!refData) return null;
  
  // Convert string ref data to object if needed
  const refObj = typeof refData === 'string' ? 
    refData.split('\n').reduce((acc, line) => {
      const [key, value] = line.split(':');
      if (key && value) acc[key.trim()] = value.trim();
      return acc;
    }, {}) : refData;
  
  // Extract relevant IDs
  return {
    campaignId: refObj.utm_campaign || refObj.hsa_cam || refObj.utm_source,
    adSetId: refObj.utm_term || refObj.hsa_grp || refObj.utm_medium,
    adId: refObj.utm_content || refObj.hsa_ad
  };
};

/**
 * DISABLED - Returns the original lead without enrichment
 */
export const enrichLeadWithMetaData = async (lead) => {
  return lead;
};

export default {
  getCampaignData,
  getAdSetData,
  getAdData,
  getAdManagerUrl,
  parseMetaIdsFromRef,
  enrichLeadWithMetaData
}; 